// window.addEventListener("load", function () {
(($) => {
  $(".colors-popup-toggle").on("click", function (e) {
    e.preventDefault();
    openPopup();
  });

  $(".colors-popup__wrap-close").on("click", function (e) {
    e.preventDefault();
    closePopup();
  });

  $(document).on("mouseup", function (e) {
    if ($(".colors-popup").is(e.target)) {
      closePopup();
    }
  });

  function openPopup() {
    $(".colors-popup").addClass("_open");
    $("body").addClass("_lock");
  }

  function closePopup() {
    $(".colors-popup").removeClass("_open");
    $("body").removeClass("_lock");
  }
})(jQuery);
// });
